export enum Routes {
    LOGIN = '/',
    RESET_PASSWORD = '/reset-password',
    SET_PASSWORD = '/set-password',
    ACTIVATE_ACCOUNT = '/activate-account',
    COMPLETE_PASSWORD_RESET = '/complete-password-reset',
    CONFIRM_EMAIL_CHANGE = '/confirm-email-change',
    REGISTRATION_APP = '/register',
    APP_APPLE_STORE_LINK = '/apple-store',
    APP_PLAY_STORE_LINK = '/play-store',
    COLLECTIONS_LINK = '/collections-redirect',
    REPORTING_LINK = '/reporting-redirect',
    ACCOUNT_LINK = '/account-redirect',
}
